// extracted by mini-css-extract-plugin
module.exports = {"Oblong":"TextGroupSectionA_Oblong__e0uGa","TextContainer":"TextGroupSectionA_TextContainer__yImBU"};